const getRecordingByInteractionId = state => interactionId => {
  return state.recordingsByInteractionId[interactionId];
};

const getCallRecordingStateByInteractionId = state => interactionId => {
  return state.callRecordingStateByInteractionId[interactionId];
};

export default {
  getCallRecordingStateByInteractionId,
  getRecordingByInteractionId
};
